<template>
  <section
    v-if="total"
    class="is-card is-flex is-flex-direction-column gap-3"
  >
    <h1 class="is-bolder font-lg">
      Propostas CLT com margem
    </h1>
    <p>
      Acompanhe aqui os clientes que já passaram pela
      consulta e ainda podem seguir para a digitação da proposta.
    </p>

    <section class="is-flex gap-5 w-full clt_cards">
      <!-- Total de clientes -->
      <section class="is-flex is-flex-direction-column clt_card gap-2 w-full">
        <span class="clt_card__text is-flex gap-2 is-align-items-flex-end">
          <p class="font-ul is-bolder">
            {{ total }}
          </p> {{ total === 1 ? 'cliente consultado' : 'clientes consultados' }}
        </span>
        <p class="clt_card__text">
          Clientes com margem consultada e com oportunidade de avanço.
        </p>
      </section>

      <!-- Total aprovados -->
      <section class="is-flex is-flex-direction-column clt_card gap-2 w-full">
        <span class="clt_card__text is-flex gap-2 is-align-items-flex-end">
          <p class="font-ul is-bolder is-success">
            {{ approved }}
          </p> {{ approved === 1 ? 'cliente' : 'clientes' }} com valor estimado aprovado
        </span>
        <p class="clt_card__text">
          Podem ter maior chance de seguir para a proposta.
        </p>
      </section>
    </section>

    <button
      class="button is-success"
      @click="$router.push({ name: 'worker-credit-consult' })"
    >
      <p class="is-bolder">
        Ver clientes para digitar propostas
      </p>
    </button>
  </section>
</template>

<script>
/* Services */
import {
  accountsAPI,
} from '@/services';

export default {
  name: 'HubDashboard',
  data: () => ({
    isLoading: false,
    approved: 0,
    total: 0,
  }),
  async created() {
    this.isLoading = true;
    const { data } = await accountsAPI.hub();
    const { approved, total } = data;

    this.approved = approved;
    this.total = total;
    this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/src/_utils.scss";
@import '@/assets/scss/src/_textVariables.scss';
@import '@/assets/scss/src/_buttonsVariables.scss';
@import '@/assets/scss/src/_statementVariables.scss';

.clt_cards {
  display: flex;
  flex-direction: column;

  @media (min-width: $breakpoint-desktop) {
    flex-direction: row;
  }
}

.clt_card {
  background: #fafafa;
  border: 1px solid #ececec;
  border-radius: 16px;
  padding: 14px;

  &__text {
    font-size: 14px;
    color: #646464;
  }

  &__index {
    width: 34px;
    height: 34px;
    min-width: 34px;
    border-radius: 10px;
    background: #eef1ff;
    color: #5463e6;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 16px;
  }
}

.is-success {
  color: $prata-green-600;
}

.w-full {
  width: 100%;
}

.font-ul {
  line-height: 26px !important;
}
</style>
